import { Citizenship, DocumentType } from '../../../../types'

const cisPassportData = {
  label: 'Номер паспорта',
  placeholder: 'Паспорт №',
  maxLength: 40,
}

export const RequisitesCIS = {
  [Citizenship.AM]: {
    [DocumentType.passport]: {
      label: 'Номер паспорта',
      placeholder: 'Паспорт №',
      maxLength: 40,
    },
    [DocumentType.identification]: {
      label: 'ID №',
      placeholder: '123456789',
      maxLength: 9,
    },
  },

  [Citizenship.BY]: {
    [DocumentType.passport]: {
      label: 'ID №',
      placeholder: '12345678АБ9ТР0',
      maxLength: 14,
    },
    [DocumentType.identification]: {
      label: 'ID №',
      placeholder: '12345678АБ9ТР0',
      maxLength: 14,
    },
  },

  [Citizenship.KG]: {
    [DocumentType.passport]: {
      label: 'Персональный номер',
      placeholder: '12345678901234',
      maxLength: 14,
    },
    [DocumentType.identification]: {
      label: 'Персональный номер',
      placeholder: '12345678901234',
      maxLength: 14,
    },
  },

  [Citizenship.KZ]: {
    [DocumentType.passport]: {
      label: 'ID №',
      placeholder: '123456789012',
      maxLength: 12,
    },
    [DocumentType.identification]: {
      label: 'ID №',
      placeholder: '123456789012',
      maxLength: 12,
    },
  },

  [Citizenship.UZ]: {
    [DocumentType.passport]: {
      label: 'Номер паспорта',
      placeholder: 'Паспорт №',
      maxLength: 40,
    },
    [DocumentType.identification]: {
      label: 'ID №',
      placeholder: '123456789012345',
      maxLength: 15,
    },
  },

  [Citizenship.GE]: {
    [DocumentType.identification]: {
      label: 'Персональный номер',
      placeholder: '12345678901',
      maxLength: 11,
    },
  },

  [Citizenship.TJ]: {
    [DocumentType.identification]: {
      label: 'ID №',
      placeholder: '1234567890123',
      maxLength: 13,
    },
  },
}

export const passport = {
  [Citizenship.RU]: {
    label: 'Серия и номер',
    placeholder: '1234567890',
    maxLength: 10,
  },

  [Citizenship.AM]: {
    label: 'Номер паспорта',
    placeholder: 'AS0592160',
    maxLength: 9,
  },
  [Citizenship.BY]: {
    label: 'Номер паспорта',
    placeholder: 'BY1234567',
    maxLength: 9,
  },
  [Citizenship.KG]: {
    label: 'Номер документа',
    placeholder: 'PE1234567',
    maxLength: 9,
  },
  [Citizenship.KZ]: {
    label: 'Номер паспорта',
    placeholder: 'N12345678',
    maxLength: 9,
  },
  [Citizenship.UZ]: {
    label: 'Номер документа',
    placeholder: 'AB1234567',
    maxLength: 9,
  },
  [Citizenship.GE]: cisPassportData,
  [Citizenship.TJ]: cisPassportData,
}

export const DepartmentCodeFormat = {
  [Citizenship.TJ]: {
    [DocumentType.passport]: undefined,
    [DocumentType.identification]: undefined,
  },
  [Citizenship.KZ]: {
    [DocumentType.passport]: undefined,
    [DocumentType.identification]: undefined,
  },
  [Citizenship.RU]: {
    [DocumentType.passport]: {
      label: 'Код подразделения',
      placeholder: '123-123',
      maxLength: 7,
    },
    [DocumentType.identification]: undefined,
  },
  [Citizenship.AM]: {
    [DocumentType.passport]: {
      label: 'Код подразделения/кем выдан',
      placeholder: '123',
      maxLength: 3,
    },
    [DocumentType.identification]: {
      label: 'Код подразделения/кем выдан',
      placeholder: '123',
      maxLength: 3,
    },
  },

  [Citizenship.BY]: {
    [DocumentType.passport]: undefined,
    [DocumentType.identification]: {
      label: 'Код органа, выдавшего документ',
      placeholder: '123',
      maxLength: 3,
    },
  },

  [Citizenship.UZ]: {
    [DocumentType.passport]: undefined,
    [DocumentType.identification]: {
      label: 'Код органа, выдавшего документ',
      placeholder: 'IIV 12345',
      maxLength: 9,
    },
  },

  [Citizenship.KG]: {
    [DocumentType.passport]: {
      label: 'Орган выдачи',
      placeholder: 'МКК 123456',
      maxLength: 10,
    },
    [DocumentType.identification]: {
      label: 'Орган выдачи документа',
      placeholder: 'МКК 12-345',
      maxLength: 10,
    },
  },

  [Citizenship.GE]: {
    [DocumentType.passport]: undefined,
    [DocumentType.identification]: undefined,
  },
}

export const documentNumberFormat = {
  [Citizenship.RU]: {
    placeholder: '',
    maxLength: 0,
  },
  [Citizenship.TJ]: {
    placeholder: 'A12345678',
    maxLength: 9,
  },
  [Citizenship.KZ]: {
    placeholder: '123456789',
    maxLength: 9,
  },

  [Citizenship.AM]: {
    placeholder: '123456789',
    maxLength: 9,
  },

  [Citizenship.BY]: {
    placeholder: 'BY1234567',
    maxLength: 9,
  },

  [Citizenship.UZ]: {
    placeholder: 'AD1234567',
    maxLength: 9,
  },

  [Citizenship.KG]: {
    placeholder: 'PE1234567',
    maxLength: 9,
  },

  [Citizenship.GE]: {
    placeholder: '00AB12345',
    maxLength: 9,
  },
}

export const fioPlaceholders = {
  [Citizenship.RU]: { lastName: 'Иванов', firstName: 'Иван', middleName: 'Иванович' },
  [Citizenship.TJ]: { lastName: 'Иванов', firstName: 'Иван', middleName: 'Иванович' },
  [Citizenship.KZ]: { lastName: 'Иванов', firstName: 'Иван', middleName: 'Иванович' },
  [Citizenship.AM]: { lastName: 'Ivanov', firstName: 'Ivan', middleName: 'Ivanovich' },
  [Citizenship.BY]: { lastName: 'Ivanov', firstName: 'Ivan', middleName: 'Ivanovich' },
  [Citizenship.UZ]: { lastName: 'Ivanov', firstName: 'Ivan', middleName: 'Ivanovich' },
  [Citizenship.KG]: { lastName: 'Иванов', firstName: 'Иван', middleName: 'Иванович' },
  [Citizenship.GE]: { lastName: 'Ivanov', firstName: 'Ivan', middleName: 'Ivanovich' },
}

export const passportIssuedPlaceholders = {
  [Citizenship.RU]: { [DocumentType.passport]: 'ТП 00 в городе Москва', [DocumentType.identification]: '' },
  [Citizenship.TJ]: { [DocumentType.passport]: 'ШВКД-1 ДАР ШАХРИ ИСФАРА', [DocumentType.identification]: '' },
  [Citizenship.KZ]: {
    [DocumentType.passport]: 'Министерство Юстиций',
    [DocumentType.identification]: 'Республика Казахастан',
  },
  [Citizenship.AM]: { [DocumentType.passport]: '123', [DocumentType.identification]: '123' },
  [Citizenship.BY]: { [DocumentType.passport]: 'Ministry of Internal Affairs', [DocumentType.identification]: 'Ministry of Internal Affairs' },
  [Citizenship.UZ]: { [DocumentType.passport]: 'XIVA TUMANI IIB', [DocumentType.identification]: 'IIV 12345' },
  [Citizenship.KG]: { [DocumentType.passport]: 'MKK 123456', [DocumentType.identification]: 'МКК 123456' },
  [Citizenship.GE]: { [DocumentType.passport]: 'Ministry of Justice', [DocumentType.identification]: '' },
}
